import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ManageReportService } from '../../../services/manage-report.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReasonComponent } from '../../modals/reason/reason.component';
import { MergeReportComponent } from "../../modals/merge-report/merge-report.component";
import { Categories, CategoryUiModel } from '../../new-report/category.ui.model';
import { Router, ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { combineLatest, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { AppConfig } from 'src/app/app.config';
import { TranslateService } from '@ngx-translate/core';
import _ from "lodash";

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  providers: [DatePipe]
})
export class ReportComponent implements OnInit, OnDestroy {

  public data = [];
  public checkedReportIds = [];
  public searchStr = '';
  public isInbox = false;
  public isRejected = false;
  public isAccepted = true;
  public isNoneReports = false;
  public displayAlert = false;
  public categories: Array<CategoryUiModel> = [];
  public category: CategoryUiModel;
  public isMerging = false;
  public filteredData = [];
  public filterLoading: Subscription;
  public loading = false;
  public closureClicked = false;

  currentPage = 1;
  itemsPerPage = 15;
  pageSize: number;

  public selectReport: any = null;
  popupShown = false;
  projectNames = {};

  public filterPopupShown = false;

  public startDate = new Date(2016, 0, 1);
  public filterStartDate = null;
  public filterEndDate = null;

  public transLabels = ['foot', 'bike', 'moped', 'schoolbus', 'train', 'bus_tram_metro', 'car', 'other'];
  public transports = [];

  dict: any;

  private sub: any;
  private closure: string;

  public isFilterApplied = false;

  public choices = [
    {
      'key': 'REPORTED',
      'value': 'Reported',
      'icon': 'assets/img/mark_reported.png'
    },
    {
      'key': 'COMPLETED',
      'value': 'Resolved',
      'icon': 'assets/img/mark_completed.png'
    },
    {
      'key': 'PROCESSING',
      'value': 'In Progress',
      'icon': 'assets/img/mark_neutral.png'
    }
  ];

  public filters = {
    status: {
      attribute: 'status',
      value: null,
      comparator: 'EQUALS',
    },
    startDate: {
      attribute: 'entities.created',
      value: null,
      comparator: 'GREATHER_THAN',
    },
    endDate: {
      attribute: 'entities.created',
      value: null,
      comparator: 'LESS_THAN',
    },
    transport: {
      attribute: 'transportMode',
      value: null,
      comparator: 'EQUALS',
    },
    category: {
      attribute: 'category',
      value: null,
      comparator: 'EQUALS',
    },
    street: {
      attribute: 'address',
      value: null,
      comparator: 'CONTAINS',
      subAttributes: [
        'street'
      ]
    }
  };

  @ViewChild('reportsBody', { static: false }) public reportsBody: ElementRef;

  constructor(
    private service: ManageReportService,
    private dataService: DataService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private config: AppConfig,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    const project = JSON.parse(localStorage.getItem('project_id'));

    this.projectNames[(project['projectID'] || {})['id']] = project['projectName'];
    for (const subProject of (project.children || [])) {
      this.projectNames[(subProject['projectID'] || {})['id']] = subProject['projectName'];
    }

    this.categories = Categories.get();

    const projectLng = this.translateService.getDefaultLang();

    this.dataService.getDictionary(projectLng).pipe(
      map((e) => {
        this.dict = e;

        const coun = [];
        Object.keys(e).filter(key => this.transLabels.includes(key)).reduce((obj, key) => {
          obj[key] = e[key];
          let className = '';
          let imgId = 0;
          if (key === 'foot') {
            className = 'foots';
            imgId = 1;
          } else if (key === 'bike') {
            className = 'bike';
            imgId = 2;
          } else if (key === 'moped') {
            className = 'moto';
            imgId = 3;
          } else if (key === 'schoolbus') {
            className = 'bus';
            imgId = 4;
          } else if (key === 'train') {
            className = 'train';
            imgId = 5;
          } else if (key === 'bus_tram_metro') {
            className = 'express';
            imgId = 6;
          } else if (key === 'car') {
            className = 'car';
            imgId = 7;
          } else if (key === 'other') {
            className = 'other';
            imgId = 8;
          }

          coun.push({
            key,
            'value': obj[key],
            'class': className,
            'img': imgId
          });
          return obj;
        }, {});
        return coun;

      }),
      map((items) => {
        this.transports = items.sort((a, b) => (a.img > b.img) ? 1 : -1);
      })
    ).subscribe();

    this.sub = this.route.queryParams.subscribe(params => {
      this.closure = params['closure'];
      if (params['closure'] == 'inbox') {
        this.inbox(!this.closureClicked);
      }
      else if (params['closure'] == 'rejected') {
        this.rejected(!this.closureClicked);
      }
      else {
        if (this.closure) {
          this.accepted(!this.closureClicked);
        } else {
          this.closure = 'accepted';
          this.navigateTo();
        }
      }
      this.closureClicked = false;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  resetFilters() {
    const temp = _.cloneDeep(this.filters);
    Object.keys(temp).forEach(t => {
      temp[t]['value'] = null;
    });
    this.filters = temp;
    this.category = null;
  }

  selectCategory(item) {
    this.category = item;
    this.filters.category.value = item.code;
  }

  selectTransport(event) {
    this.filters.transport.value = event;
  }

  public accept(e: MouseEvent, item) {
    e.stopPropagation();
    this.service.accept(item.projectId, item.id, null, null).subscribe(() => this.ngOnInit());
  }

  public reject(e: MouseEvent, item) {
    e.stopPropagation();
    this.modalService.open(ReasonComponent, {})
      .result
      .then(reason => {
        this
          .service
          .reject(item.projectId, item.id, reason, null)
          .subscribe(() => this.ngOnInit());
      })
      .catch(dismiss => {
      });
  }

  public onClosureHandle(closure) {
    // if (closure === this.closure) return;
    eval(`this.${closure}()`);
    this.navigateTo(closure);
  }

  public inbox(callApi = true) {
    this.isInbox = true;
    this.isRejected = false;
    this.isAccepted = false;
    this.isNoneReports = false;
    callApi && this.service
      .inbox()
      .subscribe(response => this.successCallback(response), err => this.errorCallback(err));
  }

  public rejected(callApi = true) {
    this.isInbox = false;
    this.isRejected = true;
    this.isAccepted = false;
    this.isNoneReports = false;
    callApi && this.service
      .rejected()
      .subscribe(response => this.successCallback(response), err => this.errorCallback(err));
  }

  public accepted(callApi = true) {
    this.isInbox = false;
    this.isRejected = false;
    this.isAccepted = true;
    this.isNoneReports = false;
    callApi && this.service
      .accepted()
      .subscribe(response => this.successCallback(response), err => this.errorCallback(err));
  }

  public navigateTo(closure = 'accepted') {
    this.data = [];
    this.filteredData = this.data;
    this.searchStr = '';
    this.isFilterApplied = false;
    this.resetFilters();
    this.closureClicked = true;
    this.router.navigate(['management', 'report'], {
      queryParams: {
        closure
      }
    });
  }

  public readAlert() {
    this.displayAlert = false;
  }

  public checkedElements = () => {
    return this.data.filter(element => element.checked);
  }

  public deleteReports() {
    // debugger;

    // Get Report Record
    this.displayAlert = false;
    this.isMerging = true;

    let found = this.checkedElements();
    let reports$ = found.map(report => this.service.remove(report.projectId, report.id));

    combineLatest(reports$).subscribe(reports => {
      console.log(reports);
      this.isMerging = false;
      this.ngOnInit();
    });
  }

  public mergeReports() {

    // debugger;

    // Get Report Record
    this.displayAlert = false;
    this.isMerging = true;

    let found = this.checkedElements();

    if (found.length < 2) {
      this.displayAlert = true;
      this.isMerging = false;
      return;
    }

    let reportsData = {};

    let reports$ = found.map(report => this.dataService.getReport(report.projectId, report.id));

    combineLatest(reports$).subscribe(reports => {
      console.log(reports);
      reportsData['ids'] = reports.map(r => `${r[0].projectID.id}_${r[0].entityID.id2}`);
      reportsData['attributes'] = reports[0][0].genericAttributes.attributes;
      reportsData['transport'] = reports.map(r => r[0].genericAttributes.attributes.transportMode[0]);
      reportsData['category'] = reports.map(r => Categories.valueOf((r[0].genericAttributes.attributes.category || [])[0])).filter(c => !!c);
      reportsData['solution'] = reports.map(r => r[0].genericAttributes.attributes.solution[0]).join(' ~ ');
      reportsData['description'] = reports.map(r => r[0].genericAttributes.attributes.description[0]);
      reportsData['image'] = reports.reduce((acc, r) => acc.concat(r[0].genericAttributes.attributes.image || []), []);

      const mergeDlg = this.modalService.open(MergeReportComponent, { windowClass: "mergeModal" });
      mergeDlg.componentInstance.reportsData = reportsData;
      mergeDlg.result.then((data) => {
        this.accepted();
      }, (reason) => {
        // on dismiss
      });
      this.isMerging = false;
    });

  }

  getImgAbsoluteUrl(imgId) {
    if (imgId.indexOf('assets') != -1) return imgId;
    else return `${this.config.getHost()}/api2/public/image?image_id=${imgId}`;
  }

  sortBy(event, col) {

    let direct;
    if (event.currentTarget.classList.contains('asc')) {
      direct = 'desc';
      event.currentTarget.classList.add('desc');
      event.currentTarget.classList.remove('asc');
    }
    else {
      direct = 'asc';
      event.currentTarget.classList.remove('desc');
      event.currentTarget.classList.add('asc');
    }
    let direct_val;
    if (direct == 'asc') direct_val = 1;
    else direct_val = -1;
    if (col == 'date') this.filteredData.sort((a, b) => (a.date > b.date) ? direct_val : -direct_val);
    if (col == 'id') this.filteredData.sort((a, b) => (a.id > b.id) ? direct_val : -direct_val);
    if (col == 'parent') this.filteredData.sort((a, b) => (this.getProjectName(a.projectId) > this.getProjectName(b.projectId)) ? direct_val : -direct_val);
  }

  public selectItem(report) {

    if (this.isAccepted) {
      this.router.navigate(['management', 'report', 'accepted', report.projectId, report.id]);
    } else if (this.isInbox) {
      this.router.navigate(['management', 'report', 'inbox', report.projectId, report.id]);
    } else if (this.isRejected) {
      this.router.navigate(['management', 'report', 'rejected', report.projectId, report.id]);
    }
  }

  mergeArrays = (...arrays) => {
    let jointArray = []

    arrays.forEach(array => {
      jointArray = [...jointArray, ...array]
    })
    const uniqueArray = jointArray.reduce((newArray, item) => {
      const items = newArray.filter(itm => itm.id === item.id);
      if (items.length) {
        return newArray
      } else {
        return [...newArray, item]
      }
    }, [])
    return uniqueArray
  }

  filterAddress(address, filterValue) {
    let filtered = false;
    for (const key in address) {
      const value = address[key] ? this.translateService.instant(address[key]) : "";
      filtered = value.toLowerCase().includes(filterValue.toLowerCase());
      if (filtered) break;
    }
    return filtered;
  }

  filter(event) {
    const status = this.isAccepted ? 'ACCEPTED' : this.isInbox ? 'NEW' : this.isRejected ? 'REJECTED' : null;

    const filterValue = event.target.value;
    this.isNoneReports = false;
    this.filteredData = [];
    const that = this;
    this.filteredData = this.data.filter(function (itm) {
      if (!itm.description) {
        console.log(itm);
      }
      const description = itm.description ? that.translateService.instant(itm.description) : "",
        category = itm.category ? that.translateService.instant(itm.category.toLowerCase()) : "";

      return description.toLowerCase().includes(filterValue.toLowerCase()) ||
        itm.date.includes(filterValue.toLowerCase()) ||
        that.filterAddress(itm.address, filterValue) ||
        category.toLowerCase().includes(filterValue.toLowerCase());
    });

    this.isNoneReports = this.filteredData.length === 0;
    // if (status && filterValue) {
    //   this.filterLoading = combineLatest([
    //     this.dataService.searchReport(status, 'solution', filterValue),
    //     this.dataService.searchReport(status, 'description', filterValue),
    //   ]).pipe(
    //     switchMap(([solutionFilteredTickets, descriptionFilteredTickets]) => {
    //       const dateFilteredTickets = this.data.filter(e => this.datePipe.transform(e.date, 'dd-MM-yyyy').indexOf(filterValue) > -1)
    //       const parentFilteredTickets = this.data.filter(e => (this.getProjectName(e.projectId) || '').toLowerCase().indexOf(filterValue) > -1);
    //       this.filteredData = this.mergeArrays(solutionFilteredTickets, descriptionFilteredTickets, dateFilteredTickets, parentFilteredTickets);

    //       this.filteredData = this.filteredData.filter( function(itm){
    //         const mode = that.translateService.instant(itm.mode.toLowerCase()),
    //               description = that.translateService.instant(itm.description),
    //               source = that.translateService.instant((itm.source === 'WEBSITE' ? 'Web' : 'Smartphone').toLowerCase()),
    //               status = that.translateService.instant(itm.status.toLowerCase()),
    //               type = that.translateService.instant(itm.type.toLowerCase());

    //         return description.toLowerCase().includes(filterValue.toLowerCase()) || 
    //               itm.date.includes(filterValue.toLowerCase()) || 
    //               that.filterAddress(itm.address, filterValue) || 
    //               type.toLowerCase().includes(filterValue.toLowerCase());
    //       });

    //       this.isNoneReports = this.filteredData.length === 0;
    //       return combineLatest([]);
    //     })
    //   ).subscribe();
    // }
    // else {
    //   this.filteredData = this.data;
    //   this.isNoneReports = false;
    // }
  }

  public onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  public changePagesize(num: number): void {
    this.itemsPerPage = this.pageSize + num;
  }

  public chooseReport(event, report) {
    if (event.target.checked) {
      this.loading = true;
      this.dataService.getReport(report.projectId, report.id).subscribe(reports => {
        let reportsData = {};
        const report = reports[0];

        reportsData['id'] = report.entityID.id2;
        reportsData['ids'] = `${report.projectID.id}_${report.entityID.id2}`;
        reportsData['attributes'] = report.genericAttributes.attributes;
        reportsData['transport'] = report.genericAttributes.attributes.transportMode[0];
        reportsData['category'] = Categories.valueOf((report.genericAttributes.attributes.category || [])[0]);
        reportsData['solution'] = report.genericAttributes.attributes.solution.join(' ~ ');
        reportsData['description'] = report.genericAttributes.attributes.description[0];
        reportsData['image'] = report.genericAttributes.attributes.image || [];
        reportsData['date'] = report.timeStamp;
        reportsData['lastUpdated'] = report.lastUpdated;
        reportsData['closure'] = report.genericAttributes.attributes.closure[0];
        reportsData['status'] = report.genericAttributes.attributes.status[0];
        reportsData['project_id'] = report.entityID.id1.id;

        this.selectReport = reportsData;
        this.popupShown = true;
      });
    }
  }

  closePopup() {
    this.popupShown = false;
    this.filterPopupShown = false;
    this.loading = false;
  }

  openFilterPopup() {
    if (this.isFilterApplied) {
      this.isFilterApplied = false;
      this.resetFilters();
      if (this.closure === 'inbox') {
        this.inbox();
      } else if (this.closure === 'rejected') {
        this.rejected();
      } else {
        this.accepted();
      }
    } else {
      this.filterPopupShown = true;
      this.loading = true;
    }
  }

  closeFilterPopup() {
    this.filterPopupShown = false;
    this.loading = false;
  }

  setFilter(val) {
    this.filters.street.value = val;
  }

  applyFilter() {
    this.filterPopupShown = false;
    this.loading = true;
    this.service.applyFilters(this.filters)
      .subscribe(response => {
        this.loading = false;
        this.isFilterApplied = true;
        this.successCallback(response);
      }, err => {
        this.loading = false;
        this.errorCallback(err);
      });
  }

  private successCallback(response: any) {
    this.isNoneReports = response.length === 0;
    this.data = response.map(r => { r['checked'] = false; return r });
    this.filteredData = this.data;
  }

  private errorCallback(err: any) {
    this.isNoneReports = false;
    this.data = [];
  }

  getProjectName(projectId) {
    return this.projectNames[projectId];
  }
}
